import * as types from './mutations_type'

export const setLang = ({commit}, payload) => {
	commit(types.SET_LANG, payload)
}

export const setLangList = ({commit}, payload) => {
	commit(types.SET_LANG_LIST, payload)
}

export const setInitLang = ({commit}, payload) => {
	commit(types.SET_INIT_LANG, payload)
}

export const setLoadshow = ({commit}, payload) => {
	commit(types.SET_LOADINGSHOW, payload)
}